import { Component } from "@angular/core";

@Component({
    selector: 'app-emp-count-team',
    templateUrl: './employees-count-by-team.component.html',
    styleUrls: ['./employees-count-by-team.component.css']
})

export class EmployeeCountByTeamComponent{
    constructor(){
        
    }
}